var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "_ngcontent-wjc-c85": "",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "_ngcontent-wjc-c85": "",
    clipPath: "url(#clip0_2260_9525)"
  }, /*#__PURE__*/React.createElement("path", {
    "_ngcontent-wjc-c85": "",
    d: "M16.505 16.5C16.9165 16.5 17.25 16.1665 17.25 15.755V2.245C17.25 1.83355 16.9165 1.5 16.505 1.5H14.245C13.8335 1.5 13.5 1.83355 13.5 2.245V15.755C13.5 16.1665 13.8335 16.5 14.245 16.5H16.505Z",
    fill: "white",
    stroke: "#A2A8B0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-wjc-c85": "",
    d: "M10.1287 1.5H1.12125C0.916214 1.5 0.75 1.66621 0.75 1.87125V4.12875C0.75 4.33379 0.916215 4.5 1.12125 4.5H10.1288C10.3338 4.5 10.5 4.33379 10.5 4.12875V1.87125C10.5 1.66621 10.3338 1.5 10.1287 1.5Z",
    fill: "white",
    stroke: "#A2A8B0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-wjc-c85": "",
    d: "M10.1287 7.5H1.12125C0.916214 7.5 0.75 7.66621 0.75 7.87125V10.1287C0.75 10.3338 0.916215 10.5 1.12125 10.5H10.1288C10.3338 10.5 10.5 10.3338 10.5 10.1287V7.87125C10.5 7.66621 10.3338 7.5 10.1287 7.5Z",
    fill: "white",
    stroke: "#A2A8B0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-wjc-c85": "",
    d: "M10.1287 13.5H1.12125C0.916214 13.5 0.75 13.6662 0.75 13.8713V16.1287C0.75 16.3338 0.916215 16.5 1.12125 16.5H10.1288C10.3338 16.5 10.5 16.3338 10.5 16.1287V13.8713C10.5 13.6662 10.3338 13.5 10.1287 13.5Z",
    fill: "white",
    stroke: "#A2A8B0",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    "_ngcontent-wjc-c85": ""
  }, /*#__PURE__*/React.createElement("clipPath", {
    "_ngcontent-wjc-c85": "",
    id: "clip0_2260_9525"
  }, /*#__PURE__*/React.createElement("rect", {
    "_ngcontent-wjc-c85": "",
    width: 18,
    height: 18,
    fill: "white",
    transform: "matrix(-1 0 0 1 18 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreen);
export default __webpack_public_path__ + "static/media/full_screen.1c2e04de5ac486003c12354d7bc8ae80.svg";
export { ForwardRef as ReactComponent };